import core from '../app.core.module.js';
import infopageConfig from './infopage.config.js';
import infopageRoute from './infopage.route.js';
import infopageController from './infopage.controller.js';

angular.module('infopage', [
  // Shared modules.
  core
])
// Register config.
.config(infopageConfig)
// Register route.
.config(infopageRoute)
// Register controller.
.controller('infopageController', infopageController)

export default 'infopage';


// WEBPACK FOOTER //
// ./src/infopage/infopage.module.js